import { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  FormGroup,
  Label,
  FormText,
  Button,
} from "reactstrap";
import { FormattedMessage } from "react-intl";
import SelectCoursesAndModules from "./SelectCoursesAndModules";

export default function AddDocumentsModal(props) {
  const [documentSelected, setDocumentSelected] = useState(false);
  const [selectedModules, setSelectedModules] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [fileToUpload, setFileToUpload] = useState(null);

  let toggleDocModal = () => {
    setDocumentSelected(false);
    setSelectedModules([]);
    setSelectedCourse(null);
    props.toggleDocumentModal();
  };

  let handleFile = (e) => {
    setFileToUpload(e.target.files[0]);
    setDocumentSelected(true);
  };
  let handleCheckModules = (event, id) => {
    if (event.target.checked && !selectedModules.includes(id)) {
      setSelectedModules([...selectedModules, id]);
    } else if (!event.target.checked && selectedModules.includes(id)) {
      setSelectedModules([
        ...selectedModules.filter(function (mid) {
          return mid !== id;
        }),
      ]);
    }
  };

  let handleCheckCourses = (event, id) => {
    if (event.target.checked) {
      setSelectedCourse(id);
    } else {
      setSelectedCourse(null);
      setSelectedModules([]);
    }
  };

  let handleuppload = () => {
    let selection = { courses: [], modules: [] };
    selection.courses = selectedCourse;
    selection.modules = selectedModules;
    props.handleUploadDocument(selection, fileToUpload);
    setDocumentSelected(false);
    props.toggleDocumentModal();
  };

  return (
    <Modal isOpen={props.documentModalOpen} toggle={toggleDocModal}>
      <ModalHeader toggle={toggleDocModal}>
        <FormattedMessage id="UploadDocument" />
      </ModalHeader>
      <ModalBody>
        {!documentSelected ? (
          <FormGroup>
            <Label for="exampleFile">
              <FormattedMessage id="Documents" />
            </Label>
            <Input
              type="file"
              name="file"
              id="exampleFile"
              onChange={handleFile}
            />
            <FormText color="muted">
              <FormattedMessage id="ChooseDocumentToUpload" />
            </FormText>
          </FormGroup>
        ) : (
          <SelectCoursesAndModules
            courses={props.courses}
            handleCheckCourses={handleCheckCourses}
            handleCheckModules={handleCheckModules}
            selectedModules={selectedModules}
            selectedCourse={selectedCourse}
          />
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline onClick={toggleDocModal}>
          <FormattedMessage id="Cancel" />
        </Button>
        {documentSelected ? (
          <Button
            color="primary"
            outline
            onClick={handleuppload}
            disabled={selectedCourse === null}
          >
            Ok
          </Button>
        ) : (
          ""
        )}
      </ModalFooter>
    </Modal>
  );
}
